import storage from "/@/cool/utils/storage";
import { normalizeLang } from "/@/utils/normalizeLang";

/** 启动时可识别的语言（与 i18n supportedLngs 主码对齐） */
const SUPPORTED_LANGS = new Set(["en", "zh-CN", "zh-TW", "zh-HK", "es", "ko", "ja"]);

/** 读取 i18next 语言缓存（兼容 store JSON 编码与原生 localStorage 纯文本） */
export function readStoredI18nextLng(): string {
	if (typeof localStorage !== "undefined") {
		const raw = localStorage.getItem("i18nextLng");
		if (raw) {
			try {
				const parsed = JSON.parse(raw);
				if (typeof parsed === "string") {
					return parsed;
				}
			} catch {
				// i18next-browser-languagedetector 写入的纯文本格式
			}
			return raw;
		}
	}

	return storage.get("i18nextLng") || "";
}

/** 从浏览器语言偏好中取第一个可支持的语言 */
export function getNavigatorLang(): string {
	if (typeof navigator === "undefined") return "";

	const candidates = [
		...(Array.isArray(navigator.languages) ? navigator.languages : []),
		navigator.language
	].filter(Boolean);

	for (const item of candidates) {
		const normalized = normalizeLang(item);
		if (normalized && SUPPORTED_LANGS.has(normalized)) {
			return normalized;
		}
	}

	return "";
}

export function getCurrentLang(url?: string) {
	const href = url || (typeof window === "undefined" ? "" : window.location.href);
	let urlLang = "";

	if (href) {
		try {
			urlLang =
				new URL(
					href,
					typeof window === "undefined" ? undefined : window.location.href
				).searchParams.get("lang") || "";
		} catch {
			urlLang = "";
		}
	}

	// 优先级：URL > 本地缓存 > 浏览器语言
	const lang = normalizeLang(
		urlLang || readStoredI18nextLng() || storage.get("lang") || getNavigatorLang()
	);

	if (lang) {
		storage.set("lang", lang);
		if (typeof localStorage !== "undefined") {
			localStorage.setItem("i18nextLng", lang);
		}
	}

	return lang;
}
